<form class="form-horizontal stacked" [formGroup]="questionForm" ngfForm (formSubmit)="goToNextQuestion()">
  <fieldset>
    <legend></legend>
    <ng-content></ng-content>
    <span class="visually-hidden">{{resources.requiredFieldScreenReader}}</span>

    <div id="list-question-wrapper">
      @switch (question.type) {
        <!-- Dropdown -->
        @case (questionTypes.DropDown) {
          <ngf-form-select [label]="getResource(question.text)" [formControlName]="question.id" required id="{{question.id}}-select"
            [options]="dropdownOptions" [errorMessages]="validationMessages">
          </ngf-form-select>
        }
        <!-- Radio -->
        @case (questionTypes.Radio) {
          <ngf-form-radio [label]="getResource(question.text)" [formControlName]="question.id" id="{{question.id}}-radio"
            [errorMessages]="validationMessages" required [options]="radioOptions">
          </ngf-form-radio>
        }
      }
    </div>
    <div class="row form-group last">
      <div class="col-control col-12">
        <button type="submit" class="btn btn-primary" id="btn-next">{{resources.nextQuestion}}</button>

        @if (hasPreviousQuestion) {
          <button id="btn-prev" type="button" class="btn btn-link"
          (click)="goToPreviousQuestion()">{{resources.previousQuestion}}</button>
        }
      </div>
    </div>
  </fieldset>
</form>
